import React, { useState } from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import {
    Button, Text, Grid, Container
} from 'components/ui';
import localeUtils from 'utils/LanguageLocale';
import questionAnswerApi from 'services/api/questionAndAnswer';
import urlUtils from 'utils/Url';
import * as pdpAnalytics from 'analytics/productPage/pdpAnalytics';
import { usePDPConfig } from 'components/ProductPage/hooks/usePDPConfig';
import QuestionsAndAnswersEN from 'components/ProductPage/QuestionsAndAnswers/locales/QuestionsAndAnswers_en_US';
import QuestionsAndAnswersFR from 'components/ProductPage/QuestionsAndAnswers/locales/QuestionsAndAnswers_fr_CA';

const getText = localeUtils.getLocalisedDataFromResource(QuestionsAndAnswersEN, QuestionsAndAnswersFR);

const UnsubscribeQuestionBody = () => {
    const { isCommunityServiceEnabled } = usePDPConfig();
    const [requestSuccess, setRequestSuccess] = useState(false);
    const [requestFailed, setRequestFailed] = useState(false);

    const sendAnalytics = (continuePressed, withoutUnsubscribe) => {
        const unsubscribeSuccess = 'questions&answers:unsubscribe-success:n/a:*';
        const continueShopping = 'unsubscribe-request:continue shopping';
        const prop55 = continuePressed ? continueShopping : unsubscribeSuccess;
        const pev2 = continuePressed && withoutUnsubscribe ? continueShopping : unsubscribeSuccess;

        pdpAnalytics.trackLinkClick({
            actionInfo: prop55,
            linkName: pev2
        });
    };

    const stopNotification = () => {
        sendAnalytics(false, false);

        const subscriptionId = urlUtils.getParamsByName('subscriptionId');
        const questionId = urlUtils.getParamsByName('questionId');
        questionAnswerApi
            .unsubscribeQuestion(subscriptionId[0], questionId[0], isCommunityServiceEnabled)
            .then(() => {
                setRequestSuccess(true);
                setRequestFailed(false);
            })
            .catch(() => {
                setRequestSuccess(false);
                setRequestFailed(true);
            });
    };

    const continueShopping = withoutUnsubscribe => {
        sendAnalytics(true, withoutUnsubscribe);
        setTimeout(() => urlUtils.redirectTo('/'), 500);
    };

    const back = () => {
        urlUtils.redirectTo('/');
    };

    const successOrFailure = requestSuccess || requestFailed;

    return (
        <Container paddingTop={[4, 6]}>
            <Text
                is='h1'
                fontSize={['md', 'xl']}
                fontWeight='bold'
                lineHeight='tight'
                marginBottom='1em'
                data-at={Sephora.debug.dataAt('unsubscribe_question_title')}
                children={
                    requestSuccess
                        ? getText('unsubscribeMessage')
                        : requestFailed
                            ? getText('submissionNotReceived')
                            : getText('stopEmailNotification')
                }
            />
            <p
                data-at={Sephora.debug.dataAt('unsubscribe_question_subtitle')}
                children={requestSuccess ? getText('noLonger') : requestFailed ? getText('submissionWrong') : getText('areYouSure')}
            />
            <Grid
                gap={4}
                marginTop={[4, 6]}
                columns={[null, 2]}
                maxWidth={[null, 556]}
            >
                <Button
                    data-at={Sephora.debug.dataAt('stop_sending_email_notification_btn')}
                    variant='primary'
                    {...(successOrFailure
                        ? {
                            onClick: requestSuccess ? () => continueShopping(false) : back,
                            children: requestSuccess ? getText('continueShopping') : getText('back')
                        }
                        : {
                            onClick: stopNotification,
                            children: getText('stopSending')
                        })}
                />
                {successOrFailure ? (
                    <div />
                ) : (
                    <Button
                        variant='secondary'
                        data-at={Sephora.debug.dataAt('continue_shopping_btn')}
                        onClick={() => continueShopping(true)}
                        children={getText('continueShopping')}
                    />
                )}
            </Grid>
        </Container>
    );
};

export default wrapFunctionalComponent(UnsubscribeQuestionBody, 'UnsubscribeQuestionBody');
